import { IconName } from '@fortawesome/fontawesome-svg-core';
import { ReverseButton } from 'elements/eventView/atomic/ReverseButton';
import { EColors2, EFonts, EVariables } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    number?: number;
    title?: string;
    description?: string;
    className?: string;
    children?: React.ReactNode;
    button?: {
        text: string;
        iconName: IconName;
        onClick: () => void;
    };
    buttons?: {
        text: string;
        iconName: IconName;
        onClick: () => void;
    }[];
}

export const SplitGuide = (props: Props): JSX.Element => {
    return (
        <S_SplitGuide className={props.className}>
            {props.title && (
                <S_TitleRow>
                    {!!props.number && <S_Number>{props.number}</S_Number>}
                    <S_Title>{props.title}</S_Title>
                </S_TitleRow>
            )}

            {props.description && <S_Description>{props.description}</S_Description>}
            <S_Buttons>
                {props.button && <S_Button {...props.button} />}
                {props.buttons?.map((button) => (
                    <S_Button key={button.text} {...button} />
                ))}
            </S_Buttons>
        </S_SplitGuide>
    );
};

const S_SplitGuide = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    margin: 60px 0;
`;

const S_Title = styled.div`
    color: ${EColors2.DARK};
    font-family: ${EFonts.Bold};
    font-size: 26px;
    letter-spacing: ${EVariables.Spacing2};
`;

const S_Description = styled.div`
    color: ${EColors2.DARK};
    font-size: 15px;
    font-family: ${EFonts.InterMedium};
    margin: 20px 0 0 0;
`;

const S_Buttons = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-self: center;
    margin: 30px 0 0 0;
`;

const S_Button = styled(ReverseButton)``;

const S_TitleRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    justify-content: center;
`;

const S_Number = styled.div`
    background-color: #eaf0f5;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-family: ${EFonts.InterSemiBold};
`;
